import BaseApiAction from '@Actions/base-api-action';

export default class UpdateCognitiveResults extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'v2-update-cognitive-results',
      payload: {
        play_session_id: this._payload.play_session_id,
        user_id: this._payload.user_id,
        cognitive_results: this._payload.cognitive_results,
      }
    });
  }
}
